<script>
import lottie from "lottie-web/build/player/lottie_light.min";

export default {
  name: "LottieAnimation",
  props: {
    path: {
      type: String,
      required: true
    },
    loop: {
      type: [Boolean, Number],
      default: false
    },
    play: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default
      default: true
    },
    renderer: {
      type: String,
      default: "svg"
    },
    speed: {
      type: Number,
      default: 1
    }
  },
  emits: ["loopComplete", "complete", "enterFrame"],
  data() {
    return {
      animation: null
    };
  },
  watch: {
    path: function () {
      this.init();
    },
    play(value) {
      if (value) {
        this.playAnimation();
      } else {
        this.pauseAnimation();
      }
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const settings = {
        container: this.$refs.animationContainer,
        renderer: this.renderer,
        loop: this.loop,
        autoplay: this.play,
        path: `/assets/animations/${this.path}.json`
      };

      this.animation = lottie.loadAnimation(settings);

      this.animation.setSpeed(this.speed);

      this.animation.addEventListener("loopComplete", () => {
        this.$emit("loopComplete", this.animation);
      });
      this.animation.addEventListener("complete", () => {
        this.$emit("complete", this.animation);
      });
      this.animation.addEventListener("enterFrame", () => {
        this.$emit("enterFrame", this.animation);
      });
    },
    playAnimation() {
      this.animation?.play();
    },
    stopAnimation() {
      this.animation?.stop();
    },
    pauseAnimation() {
      this.animation?.pause();
    }
  }
};
</script>

<template>
  <div ref="animationContainer"></div>
</template>
